const alreadyLoaded = new Set<string>()

// Note: we also has `useLoadScript` in project. Let's refactor it later
export function loadScript(src: string) {
	return new Promise<void>((resolve, reject) => {
		if (alreadyLoaded.has(src)) return resolve()

		alreadyLoaded.add(src)

		// Create script
		const script = document.createElement('script')
		script.src = src
		script.async = true

		// Script event listener callbacks for load and error
		const onScriptLoad = (): void => {
			resolve()
		}

		const onScriptError = (): void => {
			// Remove from alreadyLoaded so that we can try loading again
			alreadyLoaded.delete(src)
			script.remove()

			reject(new Error(`Unable to load script ${src}`))
		}

		script.addEventListener('load', onScriptLoad)
		script.addEventListener('error', onScriptError)

		// Add script to document body
		document.body.appendChild(script)
	})
}
